<template>
    <div>
        <!-- 用户注册账户弹窗 -->
        <el-dialog :visible.sync="CompanyResetDialog" :close-on-click-modal="false" width="450px" @close="handleCloseForget">
            <div
                class="ms-title"
                style="font-size: 14px; color: #666; margin-bottom: 24px; cursor: pointer; display: flex; justify-content: center"
            >
                <span style="margin-left: 20px; min-width: 100px; text-align: center; border-bottom: #fff solid 1px; padding-bottom: 9px">{{
                    is_style ? '' : '找回企业密码'
                }}</span>
            </div>
            <!-- 用户确认身份证号弹窗 -->
            <!--            <div v-if="model">-->
            <!--                <el-form :model="cardForm" :rules="rules" ref="cardForm" label-width="0px" class="ms-content">-->
            <!--                    <el-form-item prop="id_card">-->
            <!--                        <el-input v-model="cardForm.id_card" placeholder="请输入注册时的身份证号">-->
            <!--                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg cardImg"></el-button>-->
            <!--                        </el-input>-->
            <!--                    </el-form-item>-->
            <!--                    <div class="login-btn">-->
            <!--                        <el-button type="primary" @click="confirm()">确定</el-button>-->
            <!--                    </div>-->
            <!--                    <div class="switch">-->
            <!--                        <div class="letter" @click="goRegister()">注册账号</div>-->
            <!--                        <div class="line"></div>-->
            <!--                        <div class="letter" @click="goLogin()">登录账号</div>-->
            <!--                    </div>-->
            <!--                </el-form>-->
            <!--            </div>-->
            <!-- 账号注册 -->
            <div>
                <el-form :model="forgetFormCompany" :rules="rules" ref="forgetFormCompany" label-width="0px" class="ms-content">
                    <!--                    <el-form-item prop="useName">-->
                    <!-- <div  @click="getCode()">{{ code_text }}</div> -->
                    <!--                        <SmsSend class="getCode" :mobile="forgetForm.mobile" smsType="resetpwd"></SmsSend>-->
                    <!--                        <el-input v-model="forgetFormCompany.useName" placeholder="请输入手机号" style="position: relative">-->
                    <!--                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg mobile"></el-button>-->
                    <!--                        </el-input>-->
                    <!--                    </el-form-item>-->
                    <el-form-item prop="password">
                        <!-- <div  @click="getCode()">{{ code_text }}</div> -->
                        <!--                        <SmsSend class="getCode" :mobile="forgetForm.mobile" smsType="resetpwd"></SmsSend>-->
                        <el-input v-model="forgetFormCompany.password" placeholder="请设置密码" style="position: relative">
                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg psw"></el-button>
                        </el-input>
                    </el-form-item>
                    <!--                    <el-form-item prop="captcha" style="position: relative">-->
                    <!--                        <el-input v-model="forgetFormPersonal.captcha" placeholder="请输入短信验证码">-->
                    <!--                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg code"></el-button>-->
                    <!--                            <el-link class="getCode" @click="getCode" slot="append" type="primary" :disabled="disabled">-->
                    <!--                                {{ code_text }}-->
                    <!--                            </el-link>-->
                    <!--                        </el-input>-->
                    <!--                    </el-form-item>-->
                    <!--                    <el-form-item prop="newpassword">-->
                    <!--                        <el-input type="password" placeholder="请设置新登录密码" v-model="forgetFormPersonal.newpassword">-->
                    <!--                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg psw"></el-button>-->
                    <!--                        </el-input>-->
                    <!--                    </el-form-item>-->
                    <!--                    <el-form-item prop="newpassword2">-->
                    <!--                        <el-input type="password" placeholder="请确认新登录密码" v-model="forgetFormPersonal.newpassword2">-->
                    <!--                            <el-button slot="prepend" style="width: 5px; height: 5px" class="headImg psw2"></el-button>-->
                    <!--                        </el-input>-->
                    <!--                    </el-form-item>-->
                    <div class="login-btn">
                        <el-button type="primary" @click="submintBtn()">确认修改</el-button>
                    </div>
                    <div class="switch">
                        <!--                        <div class="letter" @click="goRegister()">注册账号</div>-->
                        <!--                        <div class="line"></div>-->
                        <!--                        <div class="letter" @click="goLogin()">登录账号</div>-->
                    </div>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// import { register, isuser, forgetpsw } from '@/api/user';
// import SmsSend from '@/components/common/SmsSend';
// import user from '~/src/api/user';
import user from '@/api/user';
export default {
    components: {
        // SmsSend
    },
    data: function() {
        // const validatePass2 = (rule, value, callback) => {
        //     if (value === '') {
        //         callback(new Error('请再次输入密码'));
        //     } else if (value !== this.forgetFormCompany.newpassword) {
        //         callback(new Error('两次输入密码不一致!'));
        //     } else {
        //         callback();
        //     }
        // };
        return {
            time: 0,
            code_text: '获取验证码',
            sms: {
                mobile: '',
                event: 'resetpwd'
            },
            disabled: false,
            //title: true,
            forgetFormCompany: {
                // newpassword3: '',
                // newpassword2: '',
                // newpassword1: '',
                // newpassword: '',
                // captcha: '',
                // mobile: '',
                // type: 'mobile'
            },
            cardForm: {
                id_card: ''
            },
            rules: {
                useName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                password: [{ required: true, message: '请确认登录密码', trigger: 'blur' }],
                id_card: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
                newpassword: [
                    { required: true, message: '请设置新登录密码', trigger: 'blur' },
                    {
                        min: 6,
                        max: 20,
                        message: '密码长度在6-20位之间',
                        trigger: ['blur', 'change']
                    }
                ],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1\d{10}$/, message: '手机号格式不对', trigger: 'blur' }
                ],
                captcha: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
            }
        };
    },
    props: {
        companycode: { type: String, default: '' },
        is_style: { type: Boolean, default: false },
        CompanyResetDialog: { type: Boolean, default: false },
        companyMobile: { type: String, default: '' }
    },
    created() {
        this.forgetFormCompany.userName = this.companycode;
        // console.log(idcard, '企业的');
    },
    methods: {
        handleCloseForget() {
            // 关闭弹窗
            this.forgetFormCompany = {}; //清空表单
            //this.forgetForm = {}; //清空表单
            if (this.is_style) {
                this.$refs.forgetFormCompany.resetFields(); //清空验证
            } else {
                // this.$refs.forgetForm.resetFields(); //清空验证
                console.log('ddddd');
            }
            //通知父组件更改 忘记密码框的状态
            this.$emit('update:CompanyResetDialog', false);
            this.$emit('update:forgetDialog', false);
        },
        submintBtn() {
            this.$refs.forgetFormCompany.validate(valid => {
                if (valid) {
                    user.forgetPassWord(this.forgetFormCompany)
                        .then(res => {
                            console.log(res);
                            if (res.code == 1) {
                                this.$message.success('修改成功');
                                this.$emit('companyDialog');
                            } else {
                                this.$message.error(res.msg);
                            }
                            // this.forgetDialog = false;
                            // this.$emit('regSwitch');
                        })
                        .catch(error => {
                            this.$message.error(error.msg);
                        });
                }
            });
        }
        // getCode() {
        //     if (this.time > 0) {
        //         return false;
        //     }
        //     this.sms.mobile = this.forgetFormPersonal.mobile;
        //     let valid = this.$refs.forgetFormPersonal.validateField('mobile', mobileErr => {
        //         console.log(mobileErr);
        //         if (!mobileErr) {
        //             user.get_code(this.sms)
        //                 .then(res => {
        //                     if (res.code == 1) {
        //                         this.$message.success(`验证码发送成功`);
        //                         //成功后改为倒计时60s
        //                         this.code_text = '60秒后重试';
        //                         this.validateBtn();
        //                     } else {
        //                         this.$message.error(res.msg);
        //                     }
        //                 })
        //                 .catch(error => {
        //                     this.$message.error(error.msg);
        //                     this.btnLoading = false;
        //                 });
        //         } else {
        //             this.$message.error('请输入正确的手机号');
        //             return false;
        //         }
        //     });
        // },
        // validateBtn() {
        //     //倒计时
        //     this.time = 59;
        //     let timer = setInterval(() => {
        //         if (this.time == 0) {
        //             clearInterval(timer);
        //             this.code_text = '获取验证码';
        //             this.disabled = false;
        //         } else {
        //             this.code_text = this.time + '秒后重试';
        //             this.disabled = true;
        //             this.time--;
        //         }
        //     }, 1000);
        // }
    }
};
</script>
<style lang="less" scoped>
.getCode {
    position: absolute;
    border: 1px solid rgba(32, 53, 128, 0.16078431372549018);
    background: linear-gradient(302deg, #007ee5 0%, #05a0ff 100%, #5533ff 100%);
    padding: 0 10px;
    min-width: 100px;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    right: 1px;
    top: 0px;
    z-index: 99;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    cursor: pointer;
    color: #fff;
    font-size: 12px;
}
.login-btn {
    /deep/ .el-button--small {
        font-size: 12px !important;
        border-radius: 3px !important;
        width: 100% !important;
        background-color: #fff;
        border: #409eff 1px solid;
        color: #409eff;
        letter-spacing: 5px;
        text-indent: 5px;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
            background: #409eff;
            color: #fff;
        }
    }
}
.switch {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 34px;
    .letter {
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
            color: #1890ff;
        }
    }
    .line {
        background-color: #ccc;
        width: 1px;
        height: 14px;
        margin: 0 19px;
    }
}
/deep/ .el-dialog__body {
    padding: 10px 20px 30px !important;
}
.headImg {
    background-image: url('~@/assets/img/img.png');
    width: 5px;
    height: 5px;
    background-repeat: no-repeat;
    position: absolute;
    left: 33px;
    top: 17px;
}
.getCode {
    position: absolute;
    border: 1px solid rgba(32, 53, 128, 0.16078431372549018);
    background: linear-gradient(302deg, #007ee5 0%, #05a0ff 100%, #5533ff 100%);
    padding: 0 10px;
    min-width: 100px;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    right: 0px;
    top: 0px;
    z-index: 99;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    cursor: pointer;
    color: #fff;
    font-size: 12px;
}
.key_img {
    background-image: url('~@/assets/img/loginkey.png');
}
//.cardImg {
//    background-image: url('~@/assets/img/idcard.png');
//}
.mobile {
    background-image: url('~@/assets/img/iphone.png');
}
.code {
    background-image: url('~@/assets/img/code.png');
}
.psw {
    background-image: url('~@/assets/img/psw.png');
}
.psw2 {
    background-image: url('~@/assets/img/psw2.png');
}
.headImg {
    width: 5px;
    height: 5px;
    background-repeat: no-repeat;
    position: absolute;
    left: 33px;
    top: 17px;
}
</style>
